<template>
<div>
    <div style="background: #ffffff;position:relative;">
        <div class="search-condition-con" :class="isShowMore && 'show'">
            <div class="search-condition" >
                <span class="label">代理商</span>
                <div class="input-condition" >
                    <factor-auto-complete v-model="condition.factorID" clearable></factor-auto-complete>
                </div>
            </div>
            <div class="search-condition" style="max-width: 300px">
                <span class="label">站点</span>
                <div class="input-condition">
                    <site-auto-complete v-model="condition.siteID" :factor-id="condition.factorID" clearable></site-auto-complete>
                </div>
            </div>
            <div class="search-condition" style="min-width: 400px">
                <span class="label">400号码</span>
                <div class="input-condition">
                    <el-autocomplete v-model="condition.tellnumber" :fetch-suggestions="querySearchHotline"  @select="handleSelectHotLine" placeholder="请输入400号码"  valueKey="hotline_number"></el-autocomplete>
                </div>
                <div class="input-condition">
                    <el-autocomplete v-model="condition.telephones" :fetch-suggestions="querySearchTelephone" @select="handleSelectTelephone" placeholder="请输入400分机号"  valueKey="telephone_number"></el-autocomplete>
                </div>
            </div>
            <div class="search-condition">
                <span class="label">400号码状态</span>
                <div class="input-condition">
                    <el-select v-model="condition.status" >
                        <el-option value=""  label="不限"></el-option>
                        <el-option value="0" label="启用"></el-option>
                        <el-option value="1" label="禁用"></el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <a class="el-icon-d-arrow-left search-arrow-down" :class="!isShowMore && 'hide'" @click.stop="isShowMore = !isShowMore"></a>
        <div class="btn-condition">
            <el-button @click="handleSearch" type="primary">查 询</el-button>
            <el-button @click="resetSearch" >清空条件</el-button>
        </div>
    </div>

    <div>

        <el-table
                :data="list"
                :highlight-current-row="true"
                stripe
                tooltip-effect="dark"
                ref="multipleTable"
                v-loading="isLoading"
                header-cell-class-name="table-back"
        >
            <!-- 表头：label对应展示的名称 prop对应返回数据列表中绑定的字段名 sortable:标识当前列是否允许排序 -->

            <el-table-column width="120" label="400号码" prop="hotline_number"></el-table-column>
            <el-table-column width="90" label="分机号" prop="telephone_number"></el-table-column>
            <el-table-column  width="120"  label="代理商" prop="factor" ></el-table-column>
            <el-table-column  label="站点" prop="site_name"></el-table-column>
                <el-table-column  label="楼盘" prop="service_type"></el-table-column>
            <el-table-column  label="推广渠道" prop="source"></el-table-column>
            <el-table-column  width="120"   label="坐席转接模式" prop="model"></el-table-column>
            <el-table-column  width="120" label="已绑定坐席数" prop="seats_total"></el-table-column>
            <el-table-column  width="120" label="分机号状态" prop="tstatus"></el-table-column>
            <el-table-column  width="150" label="更新时间" prop="updated_at"></el-table-column>

            <!-- 对于不需要绑定的列则不需要绑定props,如果自定义表头的话也可以不需要绑定label  -->
            <el-table-column width="180" >
                <!-- 绑定插槽slot="header"用来实现自定义表头,slot-scope="scope"返回数据： score:{row: '', $index: number} -->
                <template slot="header"   slot-scope="scope">
                    <span style="color: #409EFF">操作</span>
                </template>
                <!-- 默认插槽绑定列表内容插槽 scope: {$index: 当前下标, row: 当前数据对象} -->
                <template slot-scope="scope">
                    <el-button  v-if='scope.row.status ==1' size="mini" v-permission="'business.telephone.status'" @click="handleStart(scope.$index, scope.row)" >启用</el-button>
                    <el-button  v-if='scope.row.status ==0' size="mini" v-permission="'business.telephone.status'"  @click="handleStop(scope.$index, scope.row)">禁用</el-button>

                </template>
            </el-table-column>
        </el-table>
        <!--  total：一共有多少条数据 page-size一个页面显示多少条数据 @current-change当点击分页数触发-->
        <template v-if="list.length > 0">
            <!-- :total="list.length" -->
            <el-pagination background layout="total,prev, pager, next" :total="pages.total" :page-size="pages.size" @current-change="currentChange"></el-pagination>
        </template>
    </div>
</div>
</template>
<style>
    .search-condition-con .search-condition{
        width: 30%;
    }
</style>
<script>
    import {
        getHotlinesForBind,
        editCunstomerHotlinesStatus,
        getHotlinesall,
        getCunstomerTelephones, getTelephones
    } from "../../../../service/hotline";
    import {CunstomerHotlinesrescission} from "../../../../service/hotline";
    import {getFactorsList} from "../../../../service/user";
    import {getSite} from "../../../../service/site";
    import {editTelephoneStatus, getTelephoneNoraml} from "../../../../service/telephone";
    import FactorAutoComplete from "../../../../components/auto-complete/factor-auto-complete";
    import SiteAutoComplete from "../../../../components/auto-complete/site-auto-complete";
    export default {
        name: 'bind',
        components: {SiteAutoComplete, FactorAutoComplete},
        data () {
            return {
                page:1,
                balacneStatusMap:{
                    3:'欠费'
                },
                statusMap:{
                    0:'正常',
                    1:'禁用',
                },
                typeMap:{
                    1:'独立大号',
                    2:'公共大号'
                },
                transMap:{
                    0:'轮询',
                    1:'智能ABC',
                    2:'一号通',
                    3:'地区路由',
                    4:'坐席百分比',
                    5:'顺序'
                },
                pages:{
                    total:'',
                    size:''
                },
                condition: {
                    factorID:'',
                    siteID:'',
                    telephoneID:"",
                    hotlineID:"",
                    factor: '',
                    site: '',
                    type: '',
                    status:'',
                    tellnumber:'',
                    telephones:"",
                    balanceStatus:''
                },
                isLoading: false, // 是否显示loading加载
                list: [],
                isShowMore: false
            }
        },
        mounted() {
            this.initData()
        },
        methods: {
            //用于代理商自动补全的查询
            async querySearchFactor (queryString, callback) {
                this.condition.factorID = '';
                let result = [];
                await getFactorsList({name:queryString}).then((data) => {
                    result = data.data
                });
                callback(result)
            },
            // 选择代理商id回调
            handleSelectFactor (item) {
                this.condition.factorID = item.id
            },
            //用于站点自动补全的查询
            async querySearchSite(queryString, callback) {
                this.condition.siteID = '';
                let result = {};
                let query = {name:queryString,'factor_id': this.condition.factorID };
                await getSite(query).then((data) => {
                    result = data.data
                });
                callback(result)
            },
            // 选择站点id回调
            handleSelectSite (item) {

                this.condition.siteID = item.id
            },
            //用于站点自动补全的查询
            async querySearchHotline(queryString, callback) {
                this.condition.hotlineID= "";
                let result = [];
                let query = {};
                query['hotline_number'] = queryString;
                await getHotlinesall(query).then((data) => {
                    result = data
                });
                callback(result)
            },
            // 选择400号id
            handleSelectHotLine (item) {
                this.condition.hotlineID = item.id
            },
            //用于站点自动补全的查询
            async querySearchTelephone(queryString, callback) {
                this.condition.telephoneID= "";
                if(!this.condition.hotlineID) {
                    this.$message({
                        message:"请选择400号",
                        type: 'error'
                    });
                    return ;
                }
                let result = [];
                let query = {};
                let id = this.condition.hotlineID;
                query['hotline_id'] =this.condition.hotlineID;
                query['telephone_number'] = queryString;
                await getTelephones(id,query).then((data) => {
                    result = data
                });
                callback(result)
            },
            // 选择400号id
            handleSelectTelephone (item) {
                this.condition.telephoneID = item.id
            },
            //清空
            resetSearch() {
                this.condition = {
                    factorID:'',
                    siteID:'',
                    factor: '',
                    site: '',
                    type: '',
                    status:'',
                    tellnumber:'',
                    balanceStatus:''
                };
                this.refreshPage();
            },
            //分页设置回调
            currentChange(page) {
                this.page = page;
                this.refreshPage();
            },
            //搜索
            handleSearch() {
                this.refreshPage();
            },
            //启用商户大号
            handleStart(i,row) {
                this.$confirm('启用后，该400号码分机号可以正常新增绑定修改坐席号码，是否确认？', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                }).then(() => {
                    let query = {};
                    query['status'] = 0;
                    this.isLoading = true;
                    editTelephoneStatus(row.customer_hotline_id,row.id,query).then(data=>{
                        this.refreshPage()
                    }).catch((e)=>{
                        this.$message({
                            message:e.message,
                            type:'error'
                        })
                    });
                    this.isLoading = false
                }).catch(() => {

                });


            },
            //禁用商户大号
            handleStop(i,row) {
                this.$confirm('禁用后，该400分机号将禁止新增绑定修改坐席号码，是否确认？', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                }).then(() => {
                    let query = {};
                    query['status'] = 1;
                    this.isLoading = true;
                    editTelephoneStatus(row.customer_hotline_id,row.id,query).then(data=>{
                        this.refreshPage()
                    });
                    this.isLoading = false
                }).catch(() => {

                });

            },
            //刷新列表
            refreshPage() {
                let query = {};
                let form =  this.condition;
                query['factor_id'] = form.factorID;
                query['site_id'] = form.siteID;
                query['type'] = form.type;
                query['status'] = form.status;
                query['hotline_id'] = form.hotlineID;
                query['telephone_id'] = form.telephoneID;
                query['balance_status'] = form.balanceStatus;

                query['page'] = this.page;
                // this.$message({
                //     type: '',
                //     message: err.message || '删除失败'
                // })
                this.isLoading = true;
                //query['factor_id'] = user.factor_id
                getTelephoneNoraml(query).then((data) => {
                    let listData = data;
                    listData.data.forEach((item,i,list)=>{
                        //如果为空则显示--,这里通过trim做清除空字符串的处理
                        if(!item.service_type.trim()) {
                            listData.data[i].service_type = '--'
                        }
                        if(!item.site_name.trim()) {
                            listData.data[i].site_name = '--'
                        }
                        if(!item.source.trim()) {
                            listData.data[i].source = '--'
                        }
                        //非欠费状态都是正常
                        if(!this.balacneStatusMap[item.status]) {
                            listData.data[i].balance = '正常'
                        } else {
                            listData.data[i].balance = this.balacneStatusMap[item.status]
                        }
                        if(!this.statusMap[item.status]) {
                            listData.data[i].tstatus = '禁用'
                        } else {
                            listData.data[i].tstatus =this.statusMap[item.status]
                        }
                        listData.data[i].model = this.transMap[item.transfer_mode];
                        listData.data[i].type = this.typeMap[item.type]
                    });
                    console.log(listData.data);
                    this.list = listData.data;
                    this.pages.size = data.pre_page;
                    this.pages.total = data.total
                });
                // 数据请求完毕取消当前页面的loading
                this.isLoading = false
            },
            /** 初始化数据请求 */
            async initData () {
                // 初始化之前设置当前页面的loading状态
                this.isLoading = true;
                // 模拟fetch请求数据....
                let query = {};
                this.refreshPage();
                // 数据请求完毕取消当前页面的loading
                this.isLoading = false
            }
        }
    }
</script>
